export default __webpack_public_path__ + "static/media/files-glery2.85e1665c.jpg";